export const AVAILABILITY_ZONE = {
  AUTO: 'AUTO',
  ZONE_1: 'ZONE_1',
  ZONE_2: 'ZONE_2',
};

export const AVAILABILITY_ZONE$ = {
  [AVAILABILITY_ZONE.AUTO]: 'Auto',
  [AVAILABILITY_ZONE.ZONE_1]: 'Zone 1',
  [AVAILABILITY_ZONE.ZONE_2]: 'Zone 2',
};
